import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"height":"auto"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "error-message",
  style: {"margin-top":"10px"}
}
const _hoisted_4 = {
  key: 2,
  style: {"margin-top":"10px","text-align":"center"}
}
const _hoisted_5 = {
  key: 3,
  class: "pagination-controls",
  style: {"margin-top":"15px","text-align":"center"}
}
const _hoisted_6 = { style: {"margin":"0 10px"} }
const _hoisted_7 = {
  key: 1,
  style: {"margin-top":"20px","text-align":"center","color":"#777"}
}
const _hoisted_8 = {
  key: 0,
  class: "order-details-content"
}
const _hoisted_9 = { style: {"text-align":"right","margin-top":"20px"} }
const _hoisted_10 = {
  key: 1,
  class: "loading-indicator"
}
const _hoisted_11 = {
  key: 0,
  class: "order-details-content"
}
const _hoisted_12 = { style: {"text-align":"right","margin-top":"20px"} }
const _hoisted_13 = {
  key: 1,
  class: "loading-indicator"
}

import { ref, onMounted, h, computed, FunctionalComponent } from "vue";
import {
  NSpace,
  NCard,
  NButton,
  NDataTable,
  NModal,
  NSelect,
  NDescriptions,
  NDescriptionsItem,
  NDatePicker,
  NFormItem,
  useMessage,
  NTabs,
  NTabPane,
  useNotification,
  useDialog,
  DataTableColumns,
  NInputGroup,
  NInput,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { useRouter } from "vue-router";
import { getCallable, getRequestEndpoint } from "@/config/env";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import { useAuth } from "@/composables/useAuth";
import { QueryInfo, ChangeStatus } from "@/model/base";
import { Order, OrderItem, Payment } from "@/model/order";
import { usePagination } from "@/composables/usePagination";
import { USER_ROUTES } from "@/assets/route_constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'Sales',
  setup(__props) {

const { loading } = useAuth();
const router = useRouter();
const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const componentKey = ref(0);

const dateRange = ref<[number, number] | null>(null);
const showPaymentResults = ref(false);

const showOrgOrderDetailsModal = ref(false);
const showPersonalOrderDetailsModal = ref(false);
const searchValue = ref<string | null>(null);

const searchTypeForType = ref("all");
const searchOptionsForType = [
  { label: "전체", value: "all" },
  { label: "기관", value: "body" },
  { label: "개인", value: "individual" },
];

const searchType = ref("client.name");

const searchOptions = [{ label: "주문자", value: "client.name" }];

const selectedOrder = ref<Order | null>(null);

const getPaymentsCallable = getCallable("getPayments");
const getOrderCallable = getCallable("getOrder");

const {
  paginatedItems: payments,
  listLoading,
  error,
  currentPage,
  hasNextPage,
  goToNextPage: composableGoToNextPage,
  goToPreviousPage: composableGoToPreviousPage,
  refreshData: composableRefreshPayments,
} = usePagination<Payment, { startDate?: string; endDate?: string }>(async (params) => getPayments(params), 10);

async function wrappedRefreshPayments(filters?: { status?: string }) {
  loading.value = true;
  await composableRefreshPayments(filters);
  loading.value = false;
}

const getPayments = async (params: any) => {
  if (searchTypeForType.value != "all") {
    params.searchKey = "type";
    params.searchValue = searchTypeForType.value.trim();
  }
  if (searchValue.value && searchValue.value.trim() !== "") {
    params.searchKey2 = searchType.value;
    params.searchValue2 = searchValue.value.trim();
  }
  return await getPaymentsCallable(params);
};

async function wrappedGoToNextPage() {
  if (!hasNextPage.value) return;
  loading.value = true;
  await composableGoToNextPage();
  loading.value = false;
}

async function wrappedGoToPreviousPage() {
  if (currentPage.value <= 1) return;
  loading.value = true;
  await composableGoToPreviousPage();
  loading.value = false;
}

async function displayOrderDetails(order: Order) {
  selectedOrder.value = order;
  if (order.type == constant.orderType.INDIVIDUAL) {
    showPersonalOrderDetailsModal.value = true;
  } else {
    showOrgOrderDetailsModal.value = true;
  }
}

function closeOrgOrderDetailsModal() {
  showOrgOrderDetailsModal.value = false;
}

function closePersonalOrderDetailsModal() {
  showPersonalOrderDetailsModal.value = false;
}

async function fetchPaymentsByDateRange() {
  if (!dateRange.value) {
    message.error("기간을 선택해주세요.");
    return;
  }
  const [startTimestamp, endTimestamp] = dateRange.value;
  const startDate = startTimestamp.toString();
  const endDate = common.addDaysToTimestamp(endTimestamp, 1).toString();

  showPaymentResults.value = false;
  loading.value = true;
  await composableRefreshPayments({ startDate, endDate });
  showPaymentResults.value = true;
  loading.value = false;
}

const columns = [
  {
    title: "견적이름",
    key: "name",
    resizable: true,
  },
  {
    title: "주문자",
    resizable: true,
    render(row: Payment) {
      if (row.client) {
        return row.client.name;
      } else {
        return "";
      }
    },
  },
  {
    title: "결제(입금)일",
    key: "pay_date",
    resizable: true,
    render(row: Payment) {
      return common.getYYYYMMDD2(new Date(Number(row.pay_date)));
    },
  },
  {
    title: "주문금액",
    key: "totalPrice",
    resizable: true,
  },
  {
    title: "결제금액",
    key: "payment_price",
    resizable: true,
  },
  {
    title: "개인/기관",
    key: "type",
    resizable: true,
    render(row: Payment) {
      return common.getOrderType(row.type);
    },
  },
  {
    title: "",
    key: "actions",
    render(row: Payment) {
      return h(
        NButton,
        {
          strong: true,
          tertiary: true,
          size: "small",
          onClick: () => viewOrder(row),
        },
        { default: () => "주문정보보기" }
      );
    },
  },
];

const orgOrderItemColumns = [
  { title: "상품명", key: "name", resizable: true },
  {
    title: "단가",
    key: "unit_price",
    resizable: true,
    render: (row: OrderItem) => `${Number(row.unit_price || 0).toLocaleString()}원`,
  },
  { title: "수량", key: "quantity", resizable: true },
  {
    title: "공급가액",
    key: "supply_price",
    resizable: true,
    render: (row: OrderItem) => `${Number(row.supply_price || 0).toLocaleString()}원`,
  },
  {
    title: "비고",
    key: "notes",
    resizable: true,
    render: (row: OrderItem) => `${row.notes || ""}`,
  },
];
const personalOrderItemColumns = [
  { title: "상품명", key: "name", resizable: true },
  {
    title: "가격",
    key: "price",
    resizable: true,
    render: (row: OrderItem) => `${Number(row.price || 0).toLocaleString()}원`,
  },
];

async function viewOrder(payment: Payment) {
  loading.value = true;
  try {
    const result = await getOrderCallable({ SK: payment.order_id });
    if (common.evalFunctionResult(result)) {
      const order = common.getItemFromFunctionResult(result) as Order;
      displayOrderDetails(order);
    } else {
      notification.error({
        title: "정보 로딩 실패",
        description: common.getResultError(result) || "신청(견적) 정보를 불러오는데 실패했습니다.",
        duration: 3000,
      });
    }
  } catch (e: any) {
    notification.error({
      title: "오류 발생",
      description: e.message || "신청(견적) 정보 로딩 중 오류가 발생했습니다.",
      duration: 3000,
    });
  } finally {
    loading.value = false;
  }
}

async function handleTabChange(tabName: string) {
  await wrappedRefreshPayments();
}

onMounted(() => {
  wrappedRefreshPayments();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "main_div",
    key: componentKey.value
  }, [
    _withDirectives(_createVNode(Loading, null, null, 512), [
      [_vShow, _unref(loading)]
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(NSpace), { vertical: "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(NCard), { style: {"margin-top":"20px","margin-left":"80px","border":"0px","min-width":"800px"} }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSpace), {
                "item-style": "display: flex;",
                align: "center"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createElementVNode("div", { style: {"font-size":"20px","font-weight":"bold"} }, "매출 관리", -1)
                ])),
                _: 1
              }),
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "content_delimiter_line" }, null, -1)),
              _createVNode(_unref(NSpace), {
                vertical: "",
                style: {"margin-top":"10px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NSpace), {
                    align: "center",
                    "item-style": "display: flex;"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NFormItem), {
                        label: "검색",
                        style: {"min-width":"350px"},
                        "label-placement": "left"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NInputGroup), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NSelect), {
                                value: searchTypeForType.value,
                                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchTypeForType).value = $event)),
                                options: searchOptionsForType,
                                style: {"width":"120px","padding-right":"10px"}
                              }, null, 8, ["value"]),
                              _createVNode(_unref(NSelect), {
                                value: searchType.value,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchType).value = $event)),
                                options: searchOptions,
                                style: {"width":"120px"}
                              }, null, 8, ["value"]),
                              _createVNode(_unref(NInput), {
                                value: searchValue.value,
                                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchValue).value = $event)),
                                placeholder: "검색어를 입력하세요",
                                clearable: ""
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NFormItem), {
                        label: "결제(입금)일 선택",
                        style: {"min-width":"300px"},
                        "label-placement": "left"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NDatePicker), {
                            value: dateRange.value,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((dateRange).value = $event)),
                            type: "daterange",
                            clearable: ""
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NFormItem), {
                        style: {"margin-bottom":"0"},
                        "label-placement": "left"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NButton), {
                            type: "primary",
                            onClick: fetchPaymentsByDateRange,
                            disabled: !dateRange.value
                          }, {
                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                              _createTextVNode(" 조회 ")
                            ])),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (showPaymentResults.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _withDirectives(_createVNode(Loading, null, null, 512), [
                      [_vShow, _unref(listLoading)]
                    ]),
                    (!_unref(listLoading) && _unref(error))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(error)), 1))
                      : _createCommentVNode("", true),
                    (!_unref(listLoading) && !_unref(error) && _unref(payments).length > 0)
                      ? (_openBlock(), _createBlock(_unref(NDataTable), {
                          key: 1,
                          columns: columns,
                          data: _unref(payments),
                          pagination: false,
                          bordered: false,
                          style: {"margin-top":"10px"}
                        }, null, 8, ["data"]))
                      : _createCommentVNode("", true),
                    (!_unref(listLoading) && !_unref(error) && _unref(payments).length === 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, " 선택된 기간에 해당하는 결제(입금) 데이터가 없습니다. "))
                      : _createCommentVNode("", true),
                    (_unref(payments).length > 0 && !_unref(listLoading) && !_unref(error))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_unref(NButton), {
                            onClick: wrappedGoToPreviousPage,
                            disabled: _unref(currentPage) === 1,
                            style: {"margin-right":"8px"}
                          }, {
                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                              _createTextVNode(" 이전 페이지 ")
                            ])),
                            _: 1
                          }, 8, ["disabled"]),
                          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(currentPage)) + " 페이지", 1),
                          _createVNode(_unref(NButton), {
                            onClick: wrappedGoToNextPage,
                            disabled: !_unref(hasNextPage)
                          }, {
                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                              _createTextVNode(" 다음 페이지 ")
                            ])),
                            _: 1
                          }, 8, ["disabled"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, "조회할 기간을 선택해주세요."))
            ]),
            _: 1
          }),
          _createVNode(_unref(NModal), {
            show: showOrgOrderDetailsModal.value,
            "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((showOrgOrderDetailsModal).value = $event)),
            preset: "card",
            style: {"width":"800px"},
            title: "견적 상세 정보",
            onAfterLeave: _ctx.onOrgOrderDetailsModalClose
          }, {
            default: _withCtx(() => [
              (selectedOrder.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_unref(NDescriptions), {
                      "label-placement": "left",
                      bordered: "",
                      column: 2,
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "견적명",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "기관명" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.client.name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "수신자 이메일" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.receiver_email), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "참조" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.cc || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "총 금액" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.totalPrice.toLocaleString()) + "원", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "상태" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(common.getStatusString(selectedOrder.value.status)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "생성일" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(common.getYYYYMMDD2(new Date(Number(selectedOrder.value.createdDate)))), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "결제 방법",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.payment_method?.type === "bank_deposit"
                    ? "계좌이체"
                    : selectedOrder.value.payment_method?.type || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        (selectedOrder.value.payment_method?.type === 'bank_deposit')
                          ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                              key: 0,
                              label: "결제 계좌",
                              span: 2
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(selectedOrder.value.payment_method.bank_name), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (selectedOrder.value.payment_method?.type === 'bank_deposit')
                          ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                              key: 1,
                              label: "입금자명",
                              span: 2
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(selectedOrder.value.payment_method.deposit_name), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (selectedOrder.value.payment_method?.type === 'bank_deposit')
                          ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                              key: 2,
                              label: "입금예정일",
                              span: 2
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(selectedOrder.value.payment_method.bank_date), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _cache[12] || (_cache[12] = _createElementVNode("h4", { style: {"margin-top":"20px","margin-bottom":"10px"} }, "견적 항목", -1)),
                    _createVNode(_unref(NDataTable), {
                      columns: orgOrderItemColumns,
                      data: selectedOrder.value.products,
                      pagination: false,
                      bordered: true,
                      size: "small"
                    }, null, 8, ["data"]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_unref(NButton), {
                        onClick: closeOrgOrderDetailsModal,
                        type: "tertiary",
                        style: {"margin-right":"10px"}
                      }, {
                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                          _createTextVNode(" 닫기 ")
                        ])),
                        _: 1
                      })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, "상세 정보를 불러오는 중..."))
            ]),
            _: 1
          }, 8, ["show", "onAfterLeave"]),
          _createVNode(_unref(NModal), {
            show: showPersonalOrderDetailsModal.value,
            "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((showPersonalOrderDetailsModal).value = $event)),
            preset: "card",
            style: {"width":"800px"},
            title: "신청 상세 정보",
            onAfterLeave: _ctx.onPersonalOrderDetailsModalClose
          }, {
            default: _withCtx(() => [
              (selectedOrder.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_unref(NDescriptions), {
                      "label-placement": "left",
                      bordered: "",
                      column: 2,
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NDescriptionsItem), { label: "신청자" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.client.uid), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "수신자 이메일" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.receiver_email || "검사 시 입력"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "금액" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(Number(selectedOrder.value.totalPrice || 0).toLocaleString()) + " 원", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "상태" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(common.getStatusString(selectedOrder.value.status)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "생성일" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(common.getYYYYMMDD2(new Date(Number(selectedOrder.value.createdDate)))), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "결제 방법",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.payment_method?.type === "bank_deposit"
                    ? "계좌이체"
                    : selectedOrder.value.payment_method?.type || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        (selectedOrder.value.payment_method?.type === 'bank_deposit')
                          ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                              key: 0,
                              label: "결제 계좌",
                              span: 2
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(selectedOrder.value.payment_method.bank_name), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (selectedOrder.value.payment_method?.type === 'bank_deposit')
                          ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                              key: 1,
                              label: "입금자명",
                              span: 2
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(selectedOrder.value.payment_method.deposit_name), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (selectedOrder.value.payment_method?.type === 'bank_deposit')
                          ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                              key: 2,
                              label: "입금예정일",
                              span: 2
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(selectedOrder.value.payment_method.bank_date), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _cache[14] || (_cache[14] = _createElementVNode("h4", { style: {"margin-top":"20px","margin-bottom":"10px"} }, "신청 항목", -1)),
                    _createVNode(_unref(NDataTable), {
                      columns: personalOrderItemColumns,
                      data: selectedOrder.value.products,
                      pagination: false,
                      bordered: true,
                      size: "small"
                    }, null, 8, ["data"]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_unref(NButton), {
                        onClick: closePersonalOrderDetailsModal,
                        type: "tertiary",
                        style: {"margin-right":"10px"}
                      }, {
                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                          _createTextVNode(" 닫기 ")
                        ])),
                        _: 1
                      })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, "상세 정보를 불러오는 중..."))
            ]),
            _: 1
          }, 8, ["show", "onAfterLeave"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})